import React from 'react';
import { Icon } from '../../../Components/Icons/Icons';
import { BoardTypeBox as Container } from './style';
import { Text } from '../../../UI/Text';

export const BoardTypeBox = ({ boardType, displayBoardType }) => {
    return (
        <Container>
            <Icon.Box size={'53x30'}>
                <Icon.Logo />
            </Icon.Box>

            {displayBoardType && (
                <Text marginTop={'12px'} opacity={0.6} fontSize={18} weight={'bold'} uppercase={true}>
                    {boardType}
                </Text>
            )}
        </Container>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Footer/BoardTypeBox.js